import { render, staticRenderFns } from "./CourseAddForm.vue?vue&type=template&id=6a9d1b45&"
import script from "./CourseAddForm.vue?vue&type=script&lang=js&"
export * from "./CourseAddForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports